import './SonarModal.scss';

import classNames from 'classnames';
import React from 'react';

import { Modal, ModalProps } from 'antd';

export interface SonarModalProps extends Omit<ModalProps, 'visible'> {
	fixedWidth?: boolean;
}

export const SonarModal: React.FC<SonarModalProps> = ({
	afterClose,
	children,
	className,
	fixedWidth,
	open,
	...rest
}) => {
	const handleAfterClose = () => {
		if (afterClose) {
			afterClose();
		}
	};

	return (
		<Modal
			afterClose={ handleAfterClose }
			className={ classNames('sonar-modal', className) }
			open={ open }
			width={ fixedWidth ? undefined : 'fit-content' }
			{ ...rest }>
			{ children }
		</Modal>
	);
};
